import React from 'react';

export default function Glyph({ name, className }) {
    return (
        <svg className={['glyph', name, className].filter(Boolean).join(' ')} role="img">
            <use xlinkHref={`#${name}`} />
        </svg>
    );
}
